import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['De-escalate stress faster (even mid-meeting)', 'Stop the mental spiraling before it ruins your night', "Sleep without the 'brain marathon' keeping you awake", 'Feel less reactive with your partner and kids', 'Return to baseline without needing a 2-day crash'];
  return <section className="py-24 px-6 bg-white" data-id="element-1">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-4">
            This isn’t about becoming “zen.” <br data-id="element-5" />
            <span className="text-teal-700" data-id="element-6">It’s about functional calm.</span>
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-7">
            You don't need to change your personality or quit your job. You just
            need to give your nervous system a way to discharge the pressure so
            you can handle your life without the internal emergency alarm
            ringing.
          </p>

          <ul className="space-y-4" data-id="element-8">
            {benefits.map((benefit, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-9">
                <div className="mt-1 w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0" data-id="element-10">
                  <Check className="w-3 h-3 text-teal-700" strokeWidth={3} data-id="element-11" />
                </div>
                <span className="text-slate-700 font-medium" data-id="element-12">{benefit}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative h-full min-h-[400px] bg-slate-100 rounded-2xl overflow-hidden" data-id="element-13">
          <img src="https://cdn.magicpatterns.com/uploads/jdZSFHanrfdyZ9w1pKEeHH/14_days.png" alt="Preview of the guide content" className="absolute inset-0 w-full h-full object-cover" data-id="element-14" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-15" />
        </motion.div>
      </div>
    </section>;
}